import { Link } from '@reach/router';
import { Button } from '@nackle/paper';
import { NavLinkDefinition } from 'components/header/NavLinkDefinition';
import React from 'react';

export function MenuItemLink(
    {
        link,
        parentPath,
        pathname,
    }: {
        link: NavLinkDefinition;
        parentPath: string;
        pathname: string;
    }
) {
    const href = parentPath + link.path;
    const active = pathname.startsWith(href) ? 'active' : '';
    const iconClass = link.icon ? `nkl-icon-${link.icon}` : '';

    return (
        <li className="nkl-popover-wrapper">
            <Link
                className={`menu-item ${active} ${iconClass}`}
                to={href}
                id={link.id}
            >
            <Button block className="nkl-popover-button" icon={link.icon} type="text" style={{color: 'white'}}>
                {link.label}
            </Button>
            </Link>
        </li>
    );
}
